import type { Vendors } from "@/types/vendors";
import axios from "axios";
import type { Ref } from "vue";
import { reactive, ref } from "vue";
import { useStore } from "vuex";
import { key } from "@/store";

export default function useVendors() {
  const store = useStore(key);
  let lstVendors: Ref<Vendors[]> = ref([]);

  async function getVendors(empresa: string) {
    try {
      await axios
        .get(store.state.url + "api/Vendors/GetVendors?company=" + empresa, {
          headers: {},
        })
        .then((response) => {
          if (response.status == 200) {
            lstVendors.value = response.data as Vendors[];
          } else {
            console.log(response.statusText);
          }
        })
        .catch(function (error) {
          console.log(error.message);
        });
    } catch (error) {
      console.log(error);
    }
  }

  return { getVendors, lstVendors };
}
